/*
 * File: ZoominfoOverview.tsx
 * Project: a-a
 * File Created: Friday, 31st October 2025 10:30:14 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 19th November 2025 8:32:28 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import ListTagsCard from './ListTagCard/ListTagsCard';
import zeplinColor from '../../../../theme/Color';
import About from './About/About';
import ImportantCard from './ImportantCard/ImportantCard';
import RecentSignal from './RecentSignal/RecentSignal';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import ContactCard from './ContactCard/ContactCard';
import CustomChip from '../../../shared/CustomChip/CustomChip';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import styles from './ZoominfoOverview.module.css';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ZoomInfoService } from '../../../../service/zoominfo.service';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import dayjs from 'dayjs';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

const ZoominfoOverview = ({
  data,
  setValue,
}: {
  data: any;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [signalData, setSignalData] = useState<any>([]);
  const [companyData, setCompanyData] = useState<any>([]);
  const [contactoading, setContactLoading] = useState(false);
  const [contactData, setContactData] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const TimeRange = ['Day', 'Week', 'Month'];
  const activityTypeOptions = ['all', 'effort'];
  const [selectedItems, setSelectedItems] = useState<{
    activityType: string[];

    time: string[];
  }>({
    activityType: [],

    time: [],
  });
  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };
  const handleClearAll = () => {
    setSelectedItems({
      activityType: [],

      time: [],
    });
  };
  // const getCompanySimilar = async (id = '', page = 1) => {
  //   try {
  //     setLoading(true);
  //     const res = await ZoomInfoService.getCompanySimilar(id, page);
  //     console.log(res);
  //     setCompanyData(res?.data?.similar);
  //     // setPageNumber((prev) => prev + 1);
  //   } catch (err) {
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const getCompanySignals = async (id = '', page = 1) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getCompanySignals(id, page);
      console.log(res);
      setSignalData(res?.items);
      setPageNumber((prev) => prev + 1);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const getCompanyContact = async (id = '', page = 1) => {
    try {
      setContactLoading(true);
      const res = await ZoomInfoService.getCompanyEmployees(id, page?.toString());
      console.log(res);
      setContactData(res?.data?.items);
      setPageNumber((prev) => prev + 1);
    } catch (err) {
      setError(true);
    } finally {
      setContactLoading(false);
    }
  };
  const applyFilter = () => {
    console.log('test');
  };
  const handleClose = () => {
    setError(false);
  };
  useEffect(() => {
    getCompanySignals(location?.pathname.split('/')[2] || '');
    getCompanyContact(location?.pathname.split('/')[2] || '');
    // getCompanySimilar(location?.pathname.split('/')[2] || '');
  }, [location?.pathname.split('/')[2]]);
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '20px', xl: '32px' },
        height: 'calc(100vh - 310px)',
        // overflowY: 'scroll',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
          overflowY: 'scroll',
          //   height: 'calc(100vh - 310px)',
          //   height: 'calc(100vh - 400px)',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '8px', xl: '16px' } }}>
          <Typography variant='responsiveHeading3'>Lists</Typography>
          <ListTagsCard isTargeted={data?.isTargeted} data={data?.item} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 4,
            overflowY: 'scroll',
          }}
        >
          <Typography variant='responsiveHeading3'>Company Details</Typography>
          <Box
            sx={{
              border: `1px solid ${zeplinColor.Neutral5}`,
              flex: 1,
              borderRadius: '14px',
              padding: '16px',
              overflowY: 'scroll',
            }}
          >
            <About data={data?.item} loading={loading} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          paddingBottom: '2rem',
          //   height: '100%',
          overflowY: 'scroll',
          //   height: 'calc(100vh - 400px)',
        }}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '8px', xl: '16px' }, flex: 2 }}
        >
          <Typography variant='responsiveHeading3'>Important to Know</Typography>
          <ImportantCard data={data?.importantToKnow} loading={loading} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 2,
            // overflowY: 'scroll',
          }}
        >
          <Typography variant='responsiveHeading3'>Signals</Typography>
          <RecentSignal data={signalData} loading={loading} />
        </Box>
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '8px', xl: '16px' }, flex: 2 }}
        >
          <Typography variant='responsiveHeading3'>Intelligence Feed</Typography>
          {!data?.intelligenceFeed?.length && !loading ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',

                gap: '32px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                  width: '100%',
                }}
              >
                <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                <Typography
                  variant='responsiveHeading3'
                  color={zeplinColor.BasicBlack}
                  sx={{ marginTop: '0px' }}
                >
                  No feeds available.
                </Typography>
              </Box>
            </Box>
          ) : (
            data?.intelligenceFeed?.map((val: any) => (
              <a
                href={`${val?.url ?? ''}`}
                // onClick={() => console.log('data')}
                rel='noopener noreferrer'
                target='_blank'
                style={{ textDecoration: 'none', color: zeplinColor.BasicBlack, cursor: 'pointer' }}
              >
                <Box
                  sx={{
                    borderRadius: '14px',
                    border: `1px solid ${zeplinColor.Neutral5}`,
                    padding: '16px',
                    display: 'flex',
                    gap: '16px',
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: '8px',
                      height: '80px',
                      width: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: zeplinColor.Neutral3,
                      padding: '10px',
                    }}
                  >
                    <img
                      src={'/assets/no-news.svg'}
                      width='80px'
                      height='80px'
                      alt='zoominfo-no-news'
                      style={{ objectFit: 'contain' }}
                    />
                  </Box>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Chip
                        label={
                          <Typography
                            variant='responsiveLabel1'
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color={zeplinColor.BasicBlack}
                          >
                            {val?.subCategory}
                          </Typography>
                        }
                        sx={{
                          backgroundColor: zeplinColor.Neutral5,
                          color: zeplinColor.Neutral1,
                          '&.MuiChip-root': {
                            height: '24px',
                            padding: '5px 12px',
                            borderRadius: '50px',
                          },
                          '& .MuiChip-label': {
                            padding: 0,
                          },
                        }}
                      />
                      <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
                        {dayjs(val?.date).format('DD MMM, YYYY')}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontWeight: 505, fontSize: '14px' }}>{val?.title}</Typography>
                  </Box>
                </Box>
              </a>
            ))
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,

          //   overflowY: 'scroll',
          //   height: 'calc(100vh - 400px)',
        }}
      >
        {' '}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 3,
            minHeight: 0,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant='responsiveHeading3'>Recommended Contacts</Typography>
            <CustomButton
              disabled={false}
              onClick={() => {
                setValue(1);
              }}
              variant='outlined'
              color='secondary'
              style={{
                // width: '30%',
                borderRadius: 50,
                height: 32,
                textAlign: 'center',
                gap: '16px',
              }}
              textStyle={{ color: zeplinColor.BasicBlack }}
              text={'See All'}
              icon={''}
              buttonVariant='buttonSmall'
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              overflowY: 'scroll',
            }}
          >
            {contactoading ? (
              [1, 2, 3, 4, 5, 6].map((val: any) => (
                <ContactCard data={val} loading={contactoading} />
              ))
            ) : !contactData?.length ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // height: 'calc(100vh - 180px)',
                  gap: '32px',
                }}
              >
                {' '}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No Recommended contacts
                  </Typography>
                </Box>
              </Box>
            ) : (
              contactData?.map((val: any) => <ContactCard data={val} loading={contactoading} />)
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 2,
            minHeight: 0,
            // overflowY: 'scroll',
            // paddingBottom: '2rem',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant='responsiveHeading3'>Similar Companies</Typography>
            <CustomButton
              disabled={false}
              onClick={() => {
                setValue(3);
              }}
              variant='outlined'
              color='secondary'
              style={{
                // width: '30%',
                borderRadius: 50,
                height: 32,
                textAlign: 'center',
                gap: '16px',
              }}
              textStyle={{ color: zeplinColor.BasicBlack }}
              text={'See All'}
              icon={''}
              buttonVariant='buttonSmall'
            />
          </Box>
          {!data?.item?.competitors?.length ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                //   height: 'calc(100vh - 180px)',
                gap: '32px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                  width: '100%',
                }}
              >
                <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                <Typography
                  variant='responsiveHeading3'
                  color={zeplinColor.BasicBlack}
                  sx={{ marginTop: '0px' }}
                >
                  No Similar companies.
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '8px', xl: '16px' },
                // flex: 2,
                // minHeight: 0,
                overflowY: 'scroll',
                paddingBottom: '2rem',
              }}
            >
              {data?.item?.competitors?.map(
                (val: any, ind: number) =>
                  ind <= 2 && (
                    <Link
                      to={`/zoominfo/${val?.id ?? ''}`}
                      // onClick={() => console.log('data')}
                      style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                    >
                      <Box
                        sx={{
                          borderRadius: '14px',
                          padding: '12px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          backgroundColor: zeplinColor.Neutral3,
                          ':hover': {
                            backgroundColor: zeplinColor.Neutral4,
                          },
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '12px',
                            alignItems: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              width: '48px',
                              height: '48px',
                              borderRadius: '8px',
                              backgroundColor: zeplinColor.Neutral1,
                            }}
                          >
                            <img
                              src={val?.logo}
                              width='48px'
                              height='48px'
                              alt='industry'
                              style={{ objectFit: 'contain', borderRadius: '8px' }}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                              }}
                            />
                          </Box>
                          <Typography sx={{ fontSize: '18px' }} color={zeplinColor.BasicBlack}>
                            {val?.name}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: '24px',
                            height: '24px',
                            backgroundColor: zeplinColor.Neutral10,
                            borderRadius: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          // onClick={() => setValue(3)}
                        >
                          <img src='/assets/arrow-next-white.svg' alt='arrow-next' />
                        </Box>
                      </Box>
                    </Link>
                  ),
              )}
            </Box>
          )}
        </Box>
        {/* <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 2,
            minHeight: 0,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Typography variant='responsiveHeading3'>Activity Feed</Typography>
              {data?.activityFeed?.length > 0 && (
                <Stack direction='row' spacing={1} sx={{ overflowX: 'auto', height: '40px' }}>
                  <CustomChip
                    variant='responsiveBody3'
                    handleClick={() => {}}
                    active={['']}
                    text='All'
                    value='all'
                    style={{ borderRadius: '50px', padding: '15px 16px' }}
                  />
                  <CustomChip
                    variant='responsiveBody3'
                    handleClick={() => {}}
                    active={['']}
                    text='Effort'
                    value={'effort'}
                    style={{ borderRadius: '50px', padding: '15px 16px' }}
                  />
                  <CustomChip
                    variant='responsiveBody3'
                    handleClick={() => {}}
                    active={['']}
                    text='Engagement'
                    value={'engagement'}
                    style={{ borderRadius: '50px', padding: '15px 16px' }}
                  />
                </Stack>
              )}
            </Box>
           
            <CustomPopOver
              setAnchorEl={setAnchorEl}
              anchorEl={anchorEl}
              id={id}
              sx={{
                borderRadius: '14px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
                marginTop: '8px',
                marginRight: '2rem',
                marginLeft: '-4rem',
              }}
            >
              <Box
                sx={{
                  //   height: { xs: '22rem', xl: '27rem' },
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    padding: '16px',
                    width: { xs: '250px', xl: '283px' },
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px',
                    height: '100%',
                    overflow: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                      Filter
                    </Typography>
                    <Typography
                      variant='responsiveButtonSmall'
                      color={
                        Object.values(selectedItems).every((val) => val.length <= 0)
                          ? zeplinColor.Neutral8
                          : zeplinColor.Brand1
                      }
                      onClick={
                        Object.values(selectedItems).every((val) => val.length <= 0)
                          ? () => {}
                          : handleClearAll
                      }
                      sx={{
                        cursor: Object.values(selectedItems).every((val) => val.length <= 0)
                          ? 'default'
                          : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      Clear All
                    </Typography>
                  </Box>

                
                  <FormGroup
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px',
                    }}
                  >
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel
                        id='demo-multiple-name-label'
                        sx={{
                          fontSize: { xs: '14px', xl: '16px' },
                          '&.Mui-focused': { color: zeplinColor.Neutral9 },
                        }}
                      >
                        Activity Type
                      </InputLabel>
                      <Select
                        labelId='demo-multiple-name-label'
                        id='demo-multiple-name'
                        multiple
                        value={selectedItems.activityType}
                        onChange={(e) => handleSelection(e, 'activityType')}
                        input={
                          <OutlinedInput
                            sx={{
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderWidth: '1px',
                                color: zeplinColor.Neutral9,
                                borderColor: zeplinColor.Neutral9,
                              },
                              // paddingLeft: '16px',
                              padding: '0px 14px',
                            }}
                            label='Record Types'
                          />
                        }
                        renderValue={(selected) => (selected as string[]).join(', ')}
                        MenuProps={MenuProps}
                        IconComponent={() => (
                          <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                        )}
                      >
                        {activityTypeOptions.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                            sx={{
                              fontSize: { xs: '12px', xl: '16px' }, // Match responsive font size
                              padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                            }}
                          >
                            <Checkbox
                              checked={selectedItems.activityType.indexOf(name) > -1}
                              sx={{
                                color: zeplinColor.BasicBlack,
                                '&.Mui-checked': {
                                  color: zeplinColor.BasicBlack,
                                },
                              }}
                            />
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel
                        id='demo-multiple-name-label'
                        sx={{
                          fontSize: { xs: '14px', xl: '16px' },
                          '&.Mui-focused': { color: zeplinColor.Neutral9 },
                        }}
                      >
                        Time range
                      </InputLabel>
                      <Select
                        labelId='demo-multiple-name-label'
                        id='demo-multiple-name'
                        // multiple
                        value={selectedItems.time}
                        onChange={(e) => handleSelection(e, 'time')}
                        input={
                          <OutlinedInput
                            sx={{
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderWidth: '1px',
                                color: zeplinColor.Neutral9,
                                borderColor: zeplinColor.Neutral9,
                              },
                              padding: '0px 14px',
                            }}
                            label='Time range'
                          />
                        }
                        IconComponent={() => (
                          <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                        )}
                        renderValue={(selected) => selected[0]}
                        MenuProps={MenuProps}
                      >
                        {TimeRange.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                            sx={{ fontSize: { xs: '14px', xl: '16px' } }}
                          >
                            <Radio
                              checked={selectedItems.time[0] === name} // Check if this radio should be selected
                              sx={{
                                color: zeplinColor.BasicBlack,
                                '&.Mui-checked': {
                                  color: zeplinColor.BasicBlack,
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: { xs: '18px', xl: '20px' },
                                },
                              }}
                            />
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                      <CustomButton
                        onClick={applyFilter}
                        variant='contained'
                        disabled={Object.values(selectedItems).every((val) => val.length <= 0)}
                        color={'primary'}
                        style={{
                          width: '100%',
                          borderRadius: '14px',
                          height: { xs: '48px', md: '56px' },
                        }}
                        textStyle={{
                          color: Object.values(selectedItems).every((val) => val.length <= 0)
                            ? zeplinColor.Neutral8
                            : zeplinColor.Neutral1,
                          fontSize: { xs: '14px', xl: '16px' },
                        }}
                        text={'Apply'}
                      />
                    </Box>
                  </FormGroup>
                </Box>
              </Box>
            </CustomPopOver>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              overflowY: 'scroll',
              minHeight: 0,
              paddingBottom: '2rem',
            }}
          >
            {!data?.activityFeed?.length ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  //   height: 'calc(100vh - 180px)',
                  gap: '32px',
                }}
              >
                {' '}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No Activity feed.
                  </Typography>
                </Box>
              </Box>
            ) : (
              data?.activityFeed?.map((val: any) => (
                <Box
                  sx={{
                    display: 'flex',
                    border: `1px solid ${zeplinColor.Neutral5}`,
                    padding: '12px',
                    gap: '12px',
                    borderRadius: '14px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      borderRadius: '8px',
                      backgroundColor: zeplinColor.Neutral3,
                      padding: '6px',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                    }}
                  >
                    <img
                      src='/assets/zoominfo-activity-email.svg'
                      width='20px'
                      height='20px'
                      alt='activity-feed'
                    />
                  </Box>
                  <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column', width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography variant='responsiveBody3'> {val?.engagementDate}</Typography>
                      <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                        {' '}
                        {val?.engagementDate}
                      </Typography>
                    </Box>
                    <Typography variant='responsiveLabel1' color={zeplinColor.Brand1}>
                      {val?.engagementType}
                    </Typography>
                  </Box>
                </Box>
              ))
            )}
            
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default ZoominfoOverview;
